import React from 'react';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import Box from '@mui/material/Box';
import { ITEM_DESCRIPTION_AND_PRICES } from 'styles/constants/appearanceSectionNames';
import {
  DinerInfoContainer,
  StyledNoItemsAddedYet,
  StyledBorder,
  StyledDinerName,
  StyledDinerAction,
  StyledCheckCircleIcon,
  StyledDeleteOutlineOutlinedIcon,
  DotFlashing
} from 'bento-ordering/group_ordering/ui_components/CartGroupOrder';
import CartGroupOrderItems from 'bento-ordering/group_ordering/components/CartGroupOrderItems';
import { selectCartGroupOrderSlug } from 'bento-ordering/cart/selectors/index';
import {
  leaveGroupOrder,
  removeGuest
} from 'bento-ordering/group_ordering/actions/index';

export const GuestDinerInfo = ({ diner }) => {
  const dispatch = useDispatch();
  const groupOrderSlug = useSelector(selectCartGroupOrderSlug);

  const onClickDeleteHandler = async () => {
    const guestUUID = diner.uuid;

    const result = await dispatch(leaveGroupOrder(groupOrderSlug, guestUUID));

    if (result?.error !== true) {
      dispatch(removeGuest(guestUUID));
    }
  };

  return (
    <>
      <StyledBorder width="16px" />
      <Box display="flex" alignItems="center">
        {diner.done_ordering ? <StyledCheckCircleIcon /> : <DotFlashing />}
        <StyledDinerName variant={ITEM_DESCRIPTION_AND_PRICES}>
          {diner.name}
        </StyledDinerName>
        <StyledDinerAction>
          {`${diner.done_ordering ? 'Done' : 'Adding items'}`}
        </StyledDinerAction>
      </Box>
      <StyledBorder flexGrow={1}>
        <Box
          sx={{
            position: 'absolute',
            top: '0',
            right: '1rem',
            cursor: 'pointer'
          }}
        >
          <StyledDeleteOutlineOutlinedIcon
            sx={{ margin: '0 8px' }}
            onClick={onClickDeleteHandler}
          />
        </Box>
      </StyledBorder>
    </>
  );
};

GuestDinerInfo.propTypes = {
  diner: PropTypes.shape({
    name: PropTypes.string.isRequired,
    done_ordering: PropTypes.bool.isRequired,
    uuid: PropTypes.string.isRequired
  })
};

const GuestsItems = ({
  guestDiners = [],
  getEditCartItemPath,
  removeItemFromCart,
  handleEditClick,
  currentCartPath
}) => {
  return (
    <>
      {guestDiners.map(guestDiner => {
        return (
          <>
            <DinerInfoContainer>
              <GuestDinerInfo diner={guestDiner} />
            </DinerInfoContainer>
            {guestDiner?.items?.length ? (
              <CartGroupOrderItems
                key={guestDiner.uuid}
                items={guestDiner?.items}
                getEditCartItemPath={getEditCartItemPath}
                removeItemFromCart={removeItemFromCart}
                handleEditClick={handleEditClick}
                currentCartPath={currentCartPath}
                hideItemActions
              />
            ) : (
              <StyledNoItemsAddedYet>No items added yet</StyledNoItemsAddedYet>
            )}
          </>
        );
      })}
    </>
  );
};

GuestsItems.propTypes = {
  guestDiners: PropTypes.array,
  getEditCartItemPath: PropTypes.func,
  removeItemFromCart: PropTypes.func,
  handleEditClick: PropTypes.func,
  currentCartPath: PropTypes.string
};

export default GuestsItems;
